import { t } from '../../utils/i18n';
import { CLOSE, EVENT_MESSAGE, SCREEN } from '../../utils/constants';
import {
    locations,
    providers,
    setEmailOptin,
    setLocationId,
    setProcedureId,
    setProviderId,
    setNoPreferenceSelected,
    setNameScreenDynamic,
    nameScreenDynamic,
    listNamePageQuestion,
    setListNamePageQuestion,
    setListDataQuestion,
    firstQuestion,
    setFirstQuestion,
    progressQuestion,
    staffId,
    selectedLocation,
    isHiddenPoweredBy,
    form,
    fileUploadChannel,
    preQuestionnairePhotosDone,
    setPreQuestionnairePhotosDone,
    questionnaireFields,
    questionnaireFormId,
    listDataQuestion,
    leadTextId,
    clearQuestionnaireContext,
    setProgressQuestion,
} from '../../utils/variables';
import {
    updateConsultRequestFields,
    updateQualificationResponses,
} from '../../services/customFieldService';
import { toastError } from '../../views/components/error';
import { uploadPhotosListeners } from '../events/uploadPhotosListeners';
import { navigateToNextPage } from '../events/navigationHelper';
import { checkboxQuestionListener } from '../events/checkboxQuestionListener';
import { dateQuestionListener } from '../events/dateQuestionListener';
import { heightQuestionListener } from '../events/heightQuestionListener';
import { navigate } from '../events/movePages';
import { numberQuestionListener } from '../events/numberQuestionListener';
import { selectQuestionListener } from '../events/selectQuestionListener';
import { textAreaQuestonListener } from '../events/textareaQuestionListener';
import { textQuestionListener } from '../events/textQuestionListener';

export function toggleSelectProcedure(state) {
    const procedure = document.querySelector('.procedure__wrapper');
    if (!procedure) return;

    if (state === CLOSE || procedure.classList.contains('open')) {
        procedure.classList.remove('open');
        parent.postMessage(EVENT_MESSAGE.ENABLE_SCROLL, "*");
    } else {
        procedure.classList.add('open');
    }
}

export function toggleSelectProvider(state) {
    const provider = document.querySelector('.providersDropdown__wrapper');
    if (!provider) return;

    if (state === CLOSE || provider.classList.contains('open')) {
        provider.classList.remove('open');
    } else {
        provider.classList.add('open');
    }
}

export function isValidFullName(name) {
    if (name.trim().includes(' ')) {
        return true;
    }
    return false;
}

export function clearInputsConsult() {
    document
        .querySelectorAll('.requestConsult__container .valid')
        .forEach((i) => {
            i.classList.remove('valid');
        });

    document
        .querySelectorAll('.requestConsult__container .invalid')
        .forEach((i) => {
            i.classList.remove('invalid');
        });

    document
        .querySelectorAll('.requestConsult__container input')
        .forEach((i) => {
            i.value = '';
        });

    clearLocationDropdown();
    clearProcedureDropdown();
    clearProviderDropdown();

    clearEmailOptin();
}

export function toggleLocationDropdown(state) {
    const location = document.querySelector('.locationsDropdown__wrapper');

    if (state === CLOSE || location.classList.contains('open')) {
        location.classList.remove('open');
    } else {
        location.classList.add('open');
    }
}

export function clearLocationDropdown() {
    setLocationId('');

    if (locations.length > 0) {
        const locationConsultElement =
            document.querySelector('#locationConsult');
        if (locationConsultElement) {
            locationConsultElement.value = '';
        }
        document
            .querySelector(
                '.requestConsult__container .locationsDropdown__wrapper'
            )
            ?.classList.remove('selected');
    }
}

export function clearProviderDropdown() {

    setProviderId('');
    setNoPreferenceSelected(false);

    if (providers.length > 1) {
        if (document.querySelector('#providerConsult')) {
            document.querySelector('#providerConsult').value = '';
        }

        if (document.querySelector('.providersDropdown__wrapper')) {
            document
                .querySelector('.providersDropdown__wrapper')
                .classList.remove('selected');
        }
    }

    if (staffId) {
        setProviderId(+staffId);
        const provider = providers?.find(p => p.id === +staffId);
        const getLocationId = provider?.location_ids?.includes(selectedLocation) ? selectedLocation : provider?.location_ids[0];
        setLocationId(getLocationId);
    }

    if (providers.length === 1) {
        const id = providers[0].id;
        setProviderId(id);
    }

}

export function clearProcedureDropdown() {
    setProcedureId('');

    document.querySelector('#procedureConsult').value = '';
    document
        .querySelector('.requestConsult__container .procedure__wrapper')
        .classList.remove('selected');
}

export function clearEmailOptin() {
    setEmailOptin(false);
    document
        .querySelectorAll('.emailOptin__checkbox')
        .forEach((i) => i.classList.remove('is-checked'));
}

export function loadCustomFields(custom_fields) {
    // A field flagged `upload_before` shows the photo-upload screen right
    // before it. If the visitor uploads (>=1 `.upload-success`), the field is
    // skipped entirely; if they skip the upload, the question is asked.
    if (
        custom_fields?.upload_before &&
        fileUploadChannel &&
        !preQuestionnairePhotosDone
    ) {
        uploadPhotosListeners(() => {
            setPreQuestionnairePhotosDone(true);
            const uploaded =
                document.querySelectorAll(
                    '.uploadPhotos__container .upload-success'
                ).length > 0;
            if (uploaded) {
                skipQuestionAfterUpload(custom_fields);
            } else {
                loadCustomFields(custom_fields);
            }
        });
        navigate(SCREEN.UPLOAD_PHOTOS);
        return;
    }
    let html = '';
    let poweredByHtml = isHiddenPoweredBy
            ? ''
            : `
                <span>${t('powered_by')}<b style="margin-left: 3px;"><u class="powered_by"></u></b></span>
            `;
    switch (custom_fields.type) {
        case 'height':
            {
                document
                    .querySelector(
                        `${nameScreenDynamic} .heightQuestionContinue__btn`
                    )
                    ?.classList.remove('disabled');
                document
                    .querySelector(
                        `${nameScreenDynamic} .heightQuestionContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const valueFeet = document.querySelector(
                    `${nameScreenDynamic} .height_feet`
                );
                const valueIn = document.querySelector(
                    `${nameScreenDynamic} .height_inch`
                );
                if (valueFeet) {
                    valueFeet.value = '';
                }
                if (valueIn) {
                    valueIn.value = '';
                }
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                document
                    .querySelector(
                        `${nameScreenDynamic} .heightQuestion__invalid`
                    )
                    ?.classList.add('hidden');
                document
                    .querySelector(`${nameScreenDynamic} .heightQuestion__valid`)
                    ?.classList.add('hidden');
                html = `
            <div class="heightQuestion__container--${custom_fields?.id} heightQuestion__container screen">
                <div class="screen__content screen--height">
                    <div class="title__wrapper">
                        <span class="back-arrow hidden" data-screen="height_question">
                            <i class="ri-arrow-left-s-line"></i>
                        </span>
                        <span class="title__content">${t('qualification_form')}</span>
                    </div>
                    <div class='progressQuestion'>
                        <span class='progressQuestion__title'>Questions 
                            <span class='questionCurrent'>${progressQuestion?.currentQuestion || 0}</span> /
                            <span class='questionTotal'>${progressQuestion?.total || 0}</span></span>
                        <div class='progressQuestion__bar'>
                            <div class='progressQuestion__bar-current' style='width: ${progressQuestion?.progress || 0}%'></div>
                        </div>
                    </div>
                    <div class="heightboxQuestion__container">
                        <div class="heightQuestions--title">${custom_fields.title}</div>
                        <div class="heightQuestion" data-name=''>
                            <input id="height_feet" type="number" min="3" max="8" class="height_feet" />
                            <h3>${t('feet')}</h3>
                            <input id="height_inch" type="number" min="0" max="11" class="height_inch"  />
                            <h3>${t('inches')}</h3>
                            <span class="heightQuestion__valid hidden">
                                <i class="ri-check-line"></i>
                            </span>
                            <span class="heightQuestion__invalid hidden">
                                <i class="ri-close-line"></i>
                            </span>
                        </div>
                    </div>
                    <div class="heightQuestion__actions">
                        <span class="backOneStep__btn back-to-before-step heightQuestionBack__btn" data-screen="heightQuestion">
                            <i class="ri-arrow-left-line"></i>
                        </span>
                        <div class="heightQuestionContinue__btn disabled">
                            ${t('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                            <div class="loading__wrapper hidden">
                                <div class="loader">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
            }

            break;
        case 'checkbox':
            {
                if (
                    document.querySelector(
                        `${nameScreenDynamic} .checkboxContinue__btn`
                    )
                ) {
                    document
                        .querySelector(
                            `${nameScreenDynamic} .checkboxContinue__btn`
                        )
                        ?.classList.remove('disabled');
                }
                document
                    .querySelector(
                        `${nameScreenDynamic} .checkboxContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                html = `
                <div class="checkboxQuestion__container checkboxQuestion__container--${custom_fields?.id} screen">
                    <div class="screen__content screen--checkbox">
                        <div class="title__wrapper">
                            <span class="back-arrow hidden" data-screen="checkbox_question">
                                <i class="ri-arrow-left-s-line"></i>
                            </span>
                            <span class="title__content">${t('qualification_form')}</span>
                        </div>
                        <div class='progressQuestion'>
                            <span class='progressQuestion__title'>Questions 
                                <span class='questionCurrent'>${progressQuestion?.currentQuestion || 0}</span> /
                                <span class='questionTotal'>${progressQuestion?.total || 0}</span></span>
                            <div class='progressQuestion__bar'>
                                <div class='progressQuestion__bar-current' style='width: ${progressQuestion?.progress || 0}%'></div>
                            </div>
                        </div>
                        <div class="content__wrapper">
                            <div class="title__form">${custom_fields?.title || custom_fields?.label || ''}</div>
                            <form name="form-checkbox">
                                <div class="selectCheckboxContainer">
                                        <div class="select__boolean">
                                            <div class="step__list">
                                                <ul class="list-basic"> 
                                                    <li class="select__radio__row"><div>
                                                        <label class="checkbox-lg-container checkbox-round">
                                                            <input id="checkbox" type="radio" name="custom_fields" value="yes">
                                                                <span class="checkmark"></span>
                                                        </label>
                                                        <h3>${t('yes')}</h3>
                                                    </div></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="select__boolean">
                                            <div class="step__list">
                                                <ul class="list-basic"> 
                                                    <li class="select__radio__row"><div>
                                                        <label class="checkbox-lg-container checkbox-round">
                                                            <input type="radio" id="checkbox" name="custom_fields" value="no">
                                                                <span class="checkmark"></span>
                                                        </label>
                                                        <h3>${t('no')}</h3>
                                                    </div></li>
                                                </ul>
                                            </div>
                                        </div>
                                </div>
                            </form>
    
                        </div>
                        <div class="checkbox__actions">
                            <span class="backOneStep__btn back-to-before-step checkboxQuestionBack__btn" data-screen="checkbox">
                                <i class="ri-arrow-left-line"></i>
                            </span>
                            <div class="checkboxContinue__btn disabled">
                                ${t('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                                <div class="loading__wrapper hidden">
                                    <div class="loader">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="widget-footer light-bg">
                        <span class="subFooter--1"></span>
                        <span class="subFooter--2"></span>
                        <span class="subFooter--3"></span>
                        <span class="subFooter--4">
                            ${poweredByHtml}
                        </span>
                        <span class="subFooter--5"></span>
                    </div>
                </div>
                `;
            }

            break;
        case 'textarea':
            {
                document
                    .querySelector(
                        `${nameScreenDynamic} .textareaContinue__btn`
                    )
                    ?.classList.remove('disabled');
                document
                    .querySelector(
                        `${nameScreenDynamic} .textareaContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const textAreaElement = document.querySelector(
                    `${nameScreenDynamic} .textareaQuestion`
                );
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                if (textAreaElement) {
                    textAreaElement.value = '';
                }
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                html = `
            <div class="textareaQuestion__container textareaQuestion__container--${custom_fields?.id} screen">
                <div class="screen__content screen--textarea">
                    <div class="title__wrapper">
                        <span class="back-arrow hidden" data-screen="textarea_question">
                            <i class="ri-arrow-left-s-line"></i>
                        </span>
                        <span class="title__content">${t('qualification_form')}</span>
                    </div>
                    <div class='progressQuestion'>
                        <span class='progressQuestion__title'>Questions 
                            <span class='questionCurrent'>${progressQuestion?.currentQuestion || 0}</span> /
                            <span class='questionTotal'>${progressQuestion?.total || 0}</span></span>
                        <div class='progressQuestion__bar'>
                            <div class='progressQuestion__bar-current' style='width: ${progressQuestion?.progress || 0}%'></div>
                        </div>
                    </div>
                    <div class="content__wrapper">
                        <div class="title__form">${custom_fields?.title || custom_fields?.label || ''}</div>
                        <form>
                            <div data-form="textareaQuestion" class="form-control">
                                <textarea class="textareaQuestion" id="textareaQuestion" placeholder=""></textarea>
                            </div>
                        </form>
                    </div>
                    <div class="textarea__actions">
                        <span class="backOneStep__btn back-to-before-step textareaQuestionBack__btn" data-screen="textarea">
                            <i class="ri-arrow-left-line"></i>
                        </span>
                        <div class="textareaContinue__btn disabled">
                            ${t('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                            <div class="loading__wrapper hidden">
                                <div class="loader">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="widget-footer light-bg">
                    <span class="subFooter--1"></span>
                    <span class="subFooter--2"></span>
                    <span class="subFooter--3"></span>
                    <span class="subFooter--4">
                        ${poweredByHtml}
                    </span>
                    <span class="subFooter--5"></span>
                </div>
            </div>
            `;
            }

            break;
        case 'text':
            {
                document
                    .querySelector(
                        `${nameScreenDynamic} .textQuestionContinue__btn`
                    )
                    ?.classList.remove('disabled');
                document
                    .querySelector(
                        `${nameScreenDynamic} .textQuestionContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const value = document.querySelector(
                    `${nameScreenDynamic} .textQuestion--input`
                );
                if (value) {
                    value.value = '';
                }
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                document
                    .querySelector(
                        `${nameScreenDynamic} .textQuestion__invalid`
                    )
                    ?.classList.add('hidden');
                document
                    .querySelector(`${nameScreenDynamic} .textQuestion__valid`)
                    ?.classList.add('hidden');
                html = `
            <div class="textQuestion__container--${custom_fields?.id} textQuestion__container screen">
                <div class="screen__content screen--text">
                    <div class="title__wrapper">
                        <span class="back-arrow hidden" data-screen="text_question">
                            <i class="ri-arrow-left-s-line"></i>
                        </span>
                        <span class="title__content">${t('qualification_form')}</span>
                    </div>
                    <div class='progressQuestion'>
                        <span class='progressQuestion__title'>Questions 
                            <span class='questionCurrent'>${progressQuestion?.currentQuestion || 0}</span> /
                            <span class='questionTotal'>${progressQuestion?.total || 0}</span></span>
                        <div class='progressQuestion__bar'>
                            <div class='progressQuestion__bar-current' style='width: ${progressQuestion?.progress || 0}%'></div>
                        </div>
                    </div>
                    <div class="textboxQuestion__container">
                        <div class="textQuestions--title">${custom_fields.title}</div>
                        <div class="textQuestion" data-name=''>
                            <span class="textQuestion__valid hidden">
                                <i class="ri-check-line"></i>
                            </span>
                            <span class="textQuestion__invalid hidden">
                                <i class="ri-close-line"></i>
                            </span>
                            <input placeholder="${custom_fields?.placeholder || ''}" id="textQuestion" class="textQuestion--input" type="text"
                                autocomplete="off">
                            <label class="textQuestion__label">Text</label>
                        </div>
                    </div>
                    <div class="textQuestion__actions">
                        <span class="backOneStep__btn back-to-before-step textQuestionBack__btn" data-screen="textQuestion">
                            <i class="ri-arrow-left-line"></i>
                        </span>
                        <div class="textQuestionContinue__btn${custom_fields?.required === false ? '' : ' disabled'}">
                            ${t('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                            <div class="loading__wrapper hidden">
                                <div class="loader">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
            }

            break;
        case 'select':
            {
                document
                    .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
                    ?.classList.remove('disabled');
                document
                    .querySelector(
                        `${nameScreenDynamic} .selectContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                html = `
                <div class="selectQuestion__container selectQuestion__container--${custom_fields?.id} screen">
                    <div class="screen__content screen--select">
                        <div class="title__wrapper">
                            <span class="back-arrow hidden" data-screen="select_question">
                                <i class="ri-arrow-left-s-line"></i>
                            </span>
                            <span class="title__content">${t('qualification_form')}</span>
                        </div>
                        <div class='progressQuestion'>
                            <span class='progressQuestion__title'>Questions 
                                <span class='questionCurrent'>${progressQuestion?.currentQuestion || 0}</span> /
                                <span class='questionTotal'>${progressQuestion?.total || 0}</span></span>
                            <div class='progressQuestion__bar'>
                                <div class='progressQuestion__bar-current' style='width: ${progressQuestion?.progress || 0}%'></div>
                            </div>
                        </div>
                        <div class="content__wrapper">
                            <div class="title__form">${custom_fields?.title || custom_fields?.label || ''}</div>
                            <div class="list-question">
                            </div>
                        </div>
                        <div class="select__actions">
                            <span class="backOneStep__btn back-to-before-step selectQuestionBack__btn" data-screen="select">
                                <i class="ri-arrow-left-line"></i>
                            </span>
                            <div class="selectContinue__btn disabled">
                                ${t('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                                <div class="loading__wrapper hidden">
                                    <div class="loader">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="widget-footer light-bg">
                        <span class="subFooter--1"></span>
                        <span class="subFooter--2"></span>
                        <span class="subFooter--3"></span>
                        <span class="subFooter--4">
                            ${poweredByHtml}
                        </span>
                        <span class="subFooter--5"></span>
                    </div>
                </div>
               `;
            }
            break;
        case 'date':
            {
                document
                    .querySelector(
                        `${nameScreenDynamic} .dateQuestionContinue__btn`
                    )
                    ?.classList.add('disabled');
                document
                    .querySelector(
                        `${nameScreenDynamic} .dateQuestionContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const valueDate = document.querySelector(
                    `${nameScreenDynamic} #questionDatepicker--${nameScreenDynamic}`
                );
                if (valueDate) {
                    valueDate.value = '';
                }
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                html = `
            <div class="dateQuestion__container dateQuestion__container--${custom_fields?.id} screen">
                <div class="screen__content screen--date">
                    <div class="title__wrapper">
                        <span class="back-arrow hidden" data-screen="date_question">
                            <i class="ri-arrow-left-s-line"></i>
                        </span>
                        <span class="title__content">${t('qualification_form')}</span>
                    </div>
                    <div class='progressQuestion'>
                        <span class='progressQuestion__title'>Questions 
                            <span class='questionCurrent'>${progressQuestion?.currentQuestion || 0}</span> /
                            <span class='questionTotal'>${progressQuestion?.total || 0}</span></span>
                        <div class='progressQuestion__bar'>
                            <div class='progressQuestion__bar-current' style='width: ${progressQuestion?.progress || 0}%'></div>
                        </div>
                    </div>
                    <div class="dateboxQuestion__container">
                        <div class="dateQuestions--title">${custom_fields?.title}</div>
                        <div class="dateQuestion">
                            <i data-feather="calendar"></i>
                            <input id="questionDatepicker--dateQuestion__container--${custom_fields?.id}" class="dateQuestion--input" type="text" placeholder="" readonly>
                        </div>
                    </div>
                    <div class="dateQuestion__actions">
                        <span class="backOneStep__btn back-to-before-step dateQuestionBack__btn" data-screen="dateQuestion">
                            <i class="ri-arrow-left-line"></i>
                        </span>
                        <div class="dateQuestionContinue__btn disabled">
                            ${t('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                            <div class="loading__wrapper hidden">
                                <div class="loader">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            `;
            }
            break;
        case 'number':
            {
                document
                    .querySelector(
                        `${nameScreenDynamic} .numberQuestionContinue__btn`
                    )
                    ?.classList.remove('disabled');
                document
                    .querySelector(
                        `${nameScreenDynamic} .numberQuestionContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const value = document.querySelector(
                    `${nameScreenDynamic} .numberQuestion--input`
                );
                if (value) {
                    value.value = '';
                }
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                document
                    .querySelector(
                        `${nameScreenDynamic} .numberQuestion__invalid`
                    )
                    ?.classList.add('hidden');
                document
                    .querySelector(`${nameScreenDynamic} .numberQuestion__valid`)
                    ?.classList.add('hidden');
                html = `
                <div class="numberQuestion__container--${custom_fields?.id} numberQuestion__container screen">
                    <div class="screen__content screen--number">
                        <div class="title__wrapper">
                            <span class="back-arrow hidden" data-screen="number_question">
                                <i class="ri-arrow-left-s-line"></i>
                            </span>
                            <span class="title__content">${t('qualification_form')}</span>
                        </div>
                        <div class='progressQuestion'>
                            <span class='progressQuestion__title'>Questions 
                                <span class='questionCurrent'>${progressQuestion?.currentQuestion || 0}</span> /
                                <span class='questionTotal'>${progressQuestion?.total || 0}</span></span>
                            <div class='progressQuestion__bar'>
                                <div class='progressQuestion__bar-current' style='width: ${progressQuestion?.progress || 0}%'></div>
                            </div>
                        </div>
                        <div class="numberboxQuestion__container">
                            <div class="numberQuestions--title">${custom_fields.title}</div>
                            <div class="numberQuestion" data-name=''>
                                <span class="numberQuestion__valid hidden">
                                    <i class="ri-check-line"></i>
                                </span>
                                <span class="numberQuestion__invalid hidden">
                                    <i class="ri-close-line"></i>
                                </span>
                                <input min="0" placeholder="" id="numberQuestion" class="numberQuestion--input" type="number"
                                    autocomplete="off">
                                <label class="numberQuestion__label">Number</label>
                            </div>
                        </div>
                        <div class="numberQuestion__actions">
                            <span class="backOneStep__btn back-to-before-step numberQuestionBack__btn" data-screen="numberQuestion">
                                <i class="ri-arrow-left-line"></i>
                            </span>
                            <div class="numberQuestionContinue__btn disabled">
                                ${t('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                                <div class="loading__wrapper hidden">
                                    <div class="loader">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            }

            break;
        case 'multi_select':
            {
                document
                    .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
                    ?.classList.remove('disabled');
                document
                    .querySelector(
                        `${nameScreenDynamic} .selectContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                html = `
                <div class="selectQuestion__container multi_selectQuestion__container--${custom_fields?.id} screen">
                    <div class="screen__content screen--select">
                        <div class="title__wrapper">
                            <span class="back-arrow hidden" data-screen="multi_select_question">
                                <i class="ri-arrow-left-s-line"></i>
                            </span>
                            <span class="title__content">${t('qualification_form')}</span>
                        </div>
                        <div class='progressQuestion'>
                            <span class='progressQuestion__title'>Questions 
                                <span class='questionCurrent'>${progressQuestion?.currentQuestion || 0}</span> /
                                <span class='questionTotal'>${progressQuestion?.total || 0}</span></span>
                            <div class='progressQuestion__bar'>
                                <div class='progressQuestion__bar-current' style='width: ${progressQuestion?.progress || 0}%'></div>
                            </div>
                        </div>
                        <div class="content__wrapper">
                            <div class="title__form">${custom_fields?.title || custom_fields?.label || ''}</div>
                            <div class="list-question">
                            </div>
                        </div>
                        <div class="select__actions">
                            <span class="backOneStep__btn back-to-before-step selectQuestionBack__btn" data-screen="multi_select">
                                <i class="ri-arrow-left-line"></i>
                            </span>
                            <div class="selectContinue__btn disabled">
                                ${t('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                                <div class="loading__wrapper hidden">
                                    <div class="loader">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="widget-footer light-bg">
                        <span class="subFooter--1"></span>
                        <span class="subFooter--2"></span>
                        <span class="subFooter--3"></span>
                        <span class="subFooter--4">
                            ${poweredByHtml}
                        </span>
                        <span class="subFooter--5"></span>
                    </div>
                </div>
               `;
            }
            break;
    }

    if (
        !listNamePageQuestion.find(
            (list) =>
                list ===
                `.${custom_fields?.type}Question__container--${custom_fields?.id}`
        )
    ) {
        document
            .querySelector('.assistant__iframe')
            .insertAdjacentHTML('beforeend', html);
    }

    if (custom_fields?.type === 'date') {
        feather.replace();
    }

    setTimeout(() => {
        checkScreenByType(custom_fields.type, custom_fields?.id);
    }, 0);
}

function checkScreenByType(type, id) {
    setNameScreenDynamic(`.${type || ''}Question__container--${id || ''}`);
    switch (type) {
        case 'text':
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic) || firstQuestion
            ) {
                textQuestionListener();
                if (!firstQuestion) {
                    listNamePageQuestion.push(nameScreenDynamic);
                }
                setFirstQuestion(false);
            }
            setListNamePageQuestion(listNamePageQuestion);
            navigate(SCREEN.TEXT_QUESTION);
            setTimeout(() => {
                const textNameInput = document.querySelector(
                    `${nameScreenDynamic} #textQuestion`
                );
                if (textNameInput !== document.activeElement) {
                    textNameInput.focus();
                }
            }, 500);
            break;
        case 'height':
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic) || firstQuestion
            ) {
                heightQuestionListener();
                if (!firstQuestion) {
                    listNamePageQuestion.push(nameScreenDynamic);
                }
                setFirstQuestion(false);
            }
            setListNamePageQuestion(listNamePageQuestion);
            navigate(SCREEN.HEIGHT_QUESTION);
            setTimeout(() => {
                if (document.getElementById('height_feet')) {
                    document.getElementById('height_feet').focus();
                }
            }, 500);
            break;
        case 'textarea':
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic) || firstQuestion
            ) {
                textAreaQuestonListener();
                if (!firstQuestion) {
                    listNamePageQuestion.push(nameScreenDynamic);
                }
                setFirstQuestion(false);
            }
            setListNamePageQuestion(listNamePageQuestion);
            navigate(SCREEN.TEXTAREA_QUESTION);
            setTimeout(() => {
                const textAreaNameInput = document.querySelector(
                    `${nameScreenDynamic} #textareaQuestion`
                );
                if (textAreaNameInput !== document.activeElement) {
                    textAreaNameInput.focus();
                }
            }, 500);
            break;
        case 'checkbox':
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic) || firstQuestion
            ) {
                checkboxQuestionListener();
                if (!firstQuestion) {
                    listNamePageQuestion.push(nameScreenDynamic);
                }
                setFirstQuestion(false);
            }
            setListNamePageQuestion(listNamePageQuestion);
            navigate(SCREEN.CHECKBOX_QUESTION);
            break;
        case 'select':
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic) || firstQuestion
            ) {
                selectQuestionListener();
                if (!firstQuestion) {
                    listNamePageQuestion.push(nameScreenDynamic);
                }
                setFirstQuestion(false);
            }
            setListNamePageQuestion(listNamePageQuestion);
            navigate(SCREEN.SELECT_QUESTION);
            break;
        case 'date':
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic) || firstQuestion
            ) {
                dateQuestionListener();
                if (!firstQuestion) {
                    listNamePageQuestion.push(nameScreenDynamic);
                }
                setFirstQuestion(false);
            }
            setListNamePageQuestion(listNamePageQuestion);
            navigate(SCREEN.DATE_QUESTION);
            setTimeout(() => {
                const dateQuestionInput = document.querySelector(
                    `${nameScreenDynamic} .dateQuestion--input.form-control.input`
                );
                if (dateQuestionInput !== document.activeElement) {
                    dateQuestionInput.focus();
                }
            }, 500);
            break;
        case 'number':
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic) || firstQuestion
            ) {
                numberQuestionListener();
                if (!firstQuestion) {
                    listNamePageQuestion.push(nameScreenDynamic);
                }
                setFirstQuestion(false);
            }
            setListNamePageQuestion(listNamePageQuestion);
            navigate(SCREEN.NUMBER_QUESTION);
            setTimeout(() => {
                const numberNameInput = document.querySelector(
                    `${nameScreenDynamic} #numberQuestion`
                );
                if (numberNameInput !== document.activeElement) {
                    numberNameInput.focus();
                }
            }, 500);
            break;
        case 'multi_select':
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic) || firstQuestion
            ) {
                selectQuestionListener();
                if (!firstQuestion) {
                    listNamePageQuestion.push(nameScreenDynamic);
                }
                setFirstQuestion(false);
            }
            setListNamePageQuestion(listNamePageQuestion);
            navigate(SCREEN.SELECT_QUESTION);
            break;
    }
}

/**
 * Advance past an `upload_before` field the visitor satisfied by uploading.
 * If it was the last question, submit the collected answers and move on
 * (mirrors the last-question path in the per-question listeners).
 */
async function skipQuestionAfterUpload(field) {
    const fields = questionnaireFields?.length
        ? questionnaireFields
        : form?.appointment_channel?.qualification_form?.custom_fields
            ?? form?.form?.custom_fields
            ?? [];
    const idx = fields.findIndex((f) => f && f.id == field.id);
    if (idx !== -1 && idx < fields.length - 1) {
        setProgressQuestion({
            ...progressQuestion,
            currentQuestion: progressQuestion.currentQuestion + 1,
            progress:
                ((progressQuestion.currentQuestion + 1) /
                    progressQuestion.total) *
                100,
        });
        loadCustomFields(fields[idx + 1]);
        return;
    }
    try {
        const formId = questionnaireFormId ?? form?.form?.id;
        const fieldLabels = {};
        fields.forEach((f) => {
            if (f && f.id) {
                fieldLabels[f.id] = f.label || f.title || t('custom_field');
            }
        });
        // The skipped question has no typed answer — record the upload as its
        // response, otherwise an all-upload questionnaire submits an empty
        // payload and the API's `custom_fields => required` rule 422s.
        const answers = {
            ...listDataQuestion,
            [field.id]: listDataQuestion?.[field.id] || t('uploaded'),
        };
        if (typeof formId === 'string' && formId.startsWith('ac-')) {
            const acId = parseInt(formId.replace(/^ac-/, ''), 10);
            await updateQualificationResponses(
                leadTextId,
                acId,
                answers,
                fieldLabels
            );
        } else {
            await updateConsultRequestFields(
                leadTextId,
                answers,
                fieldLabels
            );
        }
        clearCustomFields();
        clearQuestionnaireContext();
        navigateToNextPage();
    } catch (error) {
        toastError(error.response?.data?.message);
    }
}

export function clearCustomFields() {
    /* Clear data custom_fields and list name page question */
    setListDataQuestion({});
    setListNamePageQuestion([]);
    setNameScreenDynamic('');
    if (document.querySelector('.textQuestion__container')) {
        document.querySelector('.textQuestion__container').remove();
    }
    if (document.querySelector('.textareaQuestion__container')) {
        document.querySelector('.textareaQuestion__container').remove();
        document.querySelectorAll('.textareaQuestion__container')?.forEach(element => {
            element.remove();
        });
    }
    if (document.querySelector('.checkboxQuestion__container')) {
        document.querySelector('.checkboxQuestion__container').remove();
        document.querySelectorAll('.checkboxQuestion__container')?.forEach(element => {
            element.remove();
        });
    }
    if (document.querySelector('.selectQuestion__container')) {
        document.querySelector('.selectQuestion__container').remove();
    }
    if (document.querySelector('.dateQuestion__container')) {
        document.querySelector('.dateQuestion__container').remove();
    }
    if (document.querySelector('.numberQuestion__container')) {
        document.querySelector('.numberQuestion__container').remove();
    }
    if (document.querySelector('.heightQuestion__container')) {
        document.querySelector('.heightQuestion__container').remove();
    }
}